import { createExternalRoute } from '../functions/createExternalRoute';
export const EhypBrokerWorkplaceLightRoute = createExternalRoute('ehyp-broker-workplace-light');
